/**
 * @generated SignedSource<<e7c8eaf84aadcbad11f351d09231995b>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
export enum ReverseTrialCohort {
  CONTROL = "CONTROL",
  ENROLLED = "ENROLLED",
  NOT_ENROLLED = "NOT_ENROLLED",
  UNASSIGNED = "UNASSIGNED",
  UNKNOWN = "UNKNOWN",
  VARIANT = "VARIANT",
}
export type useReverseTrialEligibleInstanceIsInReverseTrialQuery_signUpProperties_SignUpProperties =
  {
    __typename?: "SignUpProperties";
    reverseTrial: ReverseTrialCohort | null;
  };
export type useReverseTrialEligibleInstanceIsInReverseTrialQuery_Query = {
  __typename?: "Query";
  signUpProperties: useReverseTrialEligibleInstanceIsInReverseTrialQuery_signUpProperties_SignUpProperties | null;
};
export type useReverseTrialEligibleInstanceIsInReverseTrialQueryVariables =
  Exact<{
    [key: string]: never;
  }>;
export type useReverseTrialEligibleInstanceIsInReverseTrialQuery =
  useReverseTrialEligibleInstanceIsInReverseTrialQuery_Query;
